import { ValueWithRandom } from "@tsparticles/engine";
export class SplitFactor extends ValueWithRandom {
    constructor() {
        super();
        this.value = 3;
    }
}
